module.exports = "dist/logo_school.png?c2cd6011a59ba8aa1ced876bbc53dc29";